export default class Abstract {

    constructor( className ) {
        if ( this.constructor === Abstract ) {
            this.className = 'Abstract';
            this.__instanceError( 'name' );
        }

        this.className = className;
    }

    __instanceError() {
        throw new TypeError(`${this.className} is an Abstract class an should never be instantiated directly`);
    }

    __methodError( method ) {
        throw new TypeError( `${this.className}::${method} is an abstract method and should not be called directly. Please implement the ${method}() method.` )
    }

    static methodError( caller, method ) {
        throw new TypeError( `${caller}.${method}() is an abstract static method and should not be called directly. Please implement the ${method}() method.` )
    }

}